// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-link {
  outline: none !important;
  color: black !important;
  border-bottom: 4px solid transparent !important;
  padding: 0rem 1rem !important;
}

.nav-link.active {
  border: none !important;
  background-color: transparent !important;
  border-bottom: 2px solid black !important;
}

.nav-link:focus {
  outline: none !important;
}`, "",{"version":3,"sources":["webpack://./src/components/Board/BookmarksPanel/BookmarkTabs/Tab.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,uBAAA;EACA,+CAAA;EACA,6BAAA;AACF;;AAEA;EAEE,uBAAA;EACA,wCAAA;EACA,yCAAA;AAAF;;AAGA;EACE,wBAAA;AAAF","sourcesContent":[".nav-link {\n  outline: none !important;\n  color: black !important;\n  border-bottom: 4px solid transparent !important;\n  padding: 0rem 1rem !important;\n}\n\n.nav-link.active {\n  // color: var(--huckleberry-color) !important;\n  border: none !important;\n  background-color: transparent !important;\n  border-bottom: 2px solid black !important;\n}\n\n.nav-link:focus {\n  outline: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
